import { useQuery } from '@tanstack/react-query';
import { QUERY_KEYS } from '@/utils/query-keys';
import { AttachmentReportService } from '@/infra/services/attachment';

interface GetListAttachmentParams {
	table_origin: string;
	table_origin_id: string;
	organization_id: string;
	company_id: string;
}

const Service = AttachmentReportService.getInstance();

function isEnabled(params: GetListAttachmentParams): boolean {
	return (
		!!params.organization_id &&
		!!params.company_id &&
		!!params.table_origin &&
		!!params.table_origin_id
	);
}

export function useGetListAttachment(params: GetListAttachmentParams) {
	return useQuery({
		queryKey: [QUERY_KEYS.GET_ATTACHMENT_LIST, params],
		queryFn: () => Service.getAttachments(params),
		enabled: isEnabled(params)
	});
}
